import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { services } from "../mock";
import SectionHeading from "./SectionHeading";
import TechBackdrop from "./TechBackdrop";

function ServiceCard({ s }) {
  const Icon = Icons[s.icon] || Icons.Server;
  return (
    <Link
      to={`/services#${s.id}`}
      className="group relative rounded-2xl p-6 lg:p-7 bg-white border border-slate-200 hover-lift flex flex-col"
    >
      <div className="absolute inset-x-6 -top-px h-px bg-gradient-to-r from-transparent via-brand-400/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
      <div className="h-12 w-12 rounded-xl bg-brand-50 text-brand-700 grid place-items-center border border-brand-100 group-hover:bg-brand-700 group-hover:text-white transition-colors">
        <Icon className="h-6 w-6" />
      </div>
      <h3 className="font-display mt-5 text-xl font-semibold text-slate-900">{s.title}</h3>
      <p className="mt-2 text-[14px] leading-relaxed text-slate-600 flex-1">{s.short}</p>
      <div className="mt-5 flex items-center gap-1.5 text-brand-700 font-medium text-[13px]">
        Explore
        <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </div>
    </Link>
  );
}

export default function ServicesGrid() {
  return (
    <section className="relative py-20 lg:py-28 overflow-hidden">
      <TechBackdrop variant="hex" opacity={0.05} />
      <div className="absolute -top-32 right-0 w-[28rem] h-[28rem] rounded-full bg-gradient-to-br from-brand-100/60 to-transparent blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading
          eyebrow="What we do"
          title="Specialist services for the IBM Power platform"
          description="Six tight, deeply-scoped practice areas — each led by engineers who do nothing else."
          align="center"
        />
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s) => <ServiceCard key={s.id} s={s} />)}
        </div>
      </div>
    </section>
  );
}
